import pace, { routeWantsPace } from 'utils/pace'

export default (to, from, next) => {
  if (
    to.matched.some(route => routeWantsPace(route, to, from) === false) &&
    from.matched.some(route => routeWantsPace(route, to, from) === false)
  ) {
    next()

    return
  }

  pace.restart()

  next()
}
